export const ROUTES = {
  LANDING: '/',
  SIGNUP: '/signup',
  LOGIN: '/login',
  // Post-auth dashboard.
  DASHBOARD: '/dashboard',
  // Onboarding wizard (post-signup, pre-emit).
  ONBOARDING: '/onboarding',
  // Settings.
  CERT: '/settings/cert',
  API_KEYS: '/settings/api-keys',
  // Habeas Data.
  AUDIT_HISTORY: '/audit-history',
  DATA_EXPORT: '/data-export',
  // Operación.
  USAGE: '/usage',
  // Docs.
  INTEGRATION_GUIDE: '/integration-guide',
  SANDBOX: '/sandbox',
} as const

export const APP = {
  name: import.meta.env.VITE_APP_NAME ?? 'Taxor Partners',
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:8400',
  accountUrl: import.meta.env.VITE_TAX_ACCOUNT_URL ?? 'http://localhost:8410',
  // Base URL del ambiente de habilitación DIAN (sandbox). El sandbox NO es
  // un endpoint aparte — es el mismo POST /api/v1/documents contra este host.
  sandboxApiUrl: import.meta.env.VITE_SANDBOX_API_URL ?? 'https://api-hab.taxor.co',
  contactEmail: 'contacto@taxor.co',
} as const
